// src/encounter/services/use-encounter-questionnaire-response.ts
// QR reload (PROD-1354c): `GET /api/questionnaire-responses?encounter=Encounter/{id}` → the
// LATEST saved QuestionnaireResponse for the encounter (QB orders by UpdatedOn, tenant-scoped).
// 404 = nothing saved yet — a NORMAL state for a fresh encounter, mapped to `null` (settled,
// none) so it neither retries nor surfaces as an error. `data === undefined` = not settled yet.
import { useQuery } from '@tanstack/react-query';
import { get, ApiError } from '@/shared/api/api-client';
import type { QuestionnaireResponseResource } from '@/types/questionnaire-response-save-api';

export function useEncounterQuestionnaireResponse(encounterId: string | null) {
  return useQuery<QuestionnaireResponseResource | null>({
    queryKey: ['encounter-questionnaire-response', encounterId],
    enabled: !!encounterId,
    queryFn: async ({ signal }) => {
      try {
        return await get<QuestionnaireResponseResource>(
          `/api/questionnaire-responses?encounter=${encodeURIComponent(`Encounter/${encounterId}`)}`,
          { signal },
        );
      } catch (e) {
        if (e instanceof ApiError && e.status === 404) return null; // none saved yet
        throw e;
      }
    },
  });
}
